import VoidReasonMessageImpl from './void-reason-message';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;
/**
 * VoidReasonMessage component. A notification for a user about the reason leg/bet was voided.
 *
 * @function VoidReasonMessage
 * @memberof Mojito.Presentation.Components
 */

/**
 * VoidReasonMessage prop types.
 *
 * @property {string} [reason] - Void reason.
 * @memberof Mojito.Presentation.Components.VoidReasonMessage
 */
const propTypes = {
    reason: PropTypes.string,
};

export default UIView('VoidReasonMessage', VoidReasonMessageImpl, propTypes);
